export const API_ENDPOINTS = {
  receiptTypes: 'current-user/carts/${cartId}/deliverymodes',
  addresses: 'current-user/addresses',
  address: 'current-user/addresses/${addressId}',
  addressDelivery: 'current-user/carts/${cartId}/addresses/delivery',
  userShopList: 'current-user/stores',
  userShop: 'current-user/stores/${shopName}',
  paymentMode: 'current-user/carts/${cartId}/paymentmode',
  paymentModes: 'current-user/carts/${cartId}/paymentmodes',
  timeSlots: 'current-user/carts/${cartId}/shipment/options:findGroupedByDate',
  services: 'current-user/carts/${cartId}/shipment/transportsAvailability:find',
  placeOrder: 'current-user/orders',
  customerConsignment: 'current-user/carts/${cartId}/customerconsignment',
};
